import React, { useState } from "react";
import { Row, Col, Form, Input, Button, Modal, InputNumber } from "antd";
import { gql, useMutation } from "@apollo/client";
import UploadFile from "@general/UploadFile";
import ConsultationInputs from "../inputs/consultation";

const CRERATEPRODUCT = gql`
  mutation createConsultation($createConsultationInput: CreateConsultationInput!) {
    createConsultation(createConsultationInput: $createConsultationInput) {
      id
      name
    }
  }
`;
function AddConsultatin() {
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const [runCreateProduct, createProduct] = useMutation(CRERATEPRODUCT, {
    onCompleted({ createConsultation }) {
      Modal.success({
        content: `${createConsultation?.name} به خدمات صفاتک اضافه شد.`,
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: () => form.resetFields(),
      });
    },
    onError(err) {
      console.log("خطا: " + err.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });
  const doCreateProduct = (createConsultationInput) => {
    runCreateProduct({
      variables: {
        createConsultationInput,
      },
    });
  };

  return (
    <>
      <Form layout="vertical" onFinish={doCreateProduct} form={form}>
        <ConsultationInputs error={error} />
        <Button
          type="primary"
          htmlType="submit"
          loading={createProduct.loading && true}
        >
          ثبت خدمت
        </Button>
      </Form>
    </>
  );
}

export default AddConsultatin;
